import { heroStats, siteName } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full min-h-[640px] md:min-h-[720px] overflow-hidden flex items-center">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20anime%20inspired%20background%20with%20warm%20rose%20and%20gold%20gradient%20sky%2C%20soft%20glowing%20particles%2C%20flowing%20light%20ribbons%2C%20dreamy%20clouds%2C%20painterly%20minimal%20composition%2C%20no%20text%2C%20elegant%20and%20atmospheric&width=1920&height=1080&seq=yjd-anime-hero-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />

      <div className="relative z-10 w-full flex flex-col items-center justify-center text-center px-4 md:px-8 py-28 md:py-32">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm font-medium backdrop-blur-sm">
          <i className="ri-guide-line" />
          入口信息指引 · 更新于长期维护
        </span>

        <h1 className="mt-6 font-heading text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight max-w-4xl">
          {siteName}官网入口指南
        </h1>
        <p className="mt-3 font-heading text-primary-200 text-lg md:text-2xl">
          官网、APP下载与最新地址，一次看懂
        </p>

        <p className="mt-5 max-w-2xl text-background-100/90 text-sm md:text-base leading-relaxed">
          本页汇总官网入口、客户端下载与最新地址的获取方式，并附上识别真假官网、排查访问异常的实用方法。无论你是想安装客户端，还是需要刷新收藏的旧链接，都能按指引快速找到当前可用的访问方式。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
          <a
            href="#address"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-links-line" />
            查看最新地址
          </a>
          <a
            href="#app"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-download-2-line" />
            了解 APP 下载
          </a>
        </div>

        <div className="mt-12 w-full max-w-3xl grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {heroStats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm px-3 py-3 text-center"
            >
              <div className="font-heading text-accent-300 text-xl md:text-2xl">{item.value}</div>
              <div className="mt-1 text-background-100/80 text-xs md:text-sm">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}